<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="demo-block demo-box demo-zh-CN demo-form" >
          <el-form class="formdiv" ref="form"  label-width="80px">
            <el-form-item label="众筹名称">
              <el-input ></el-input>
            </el-form-item>
            <el-form-item label="活动区域">
              <el-select  placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="活动时间">
              <el-col :span="11">
                <el-date-picker type="date" placeholder="选择日期"  style="width: 100%;"></el-date-picker>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-time-picker type="fixed-time" placeholder="选择时间" style="width: 100%;"></el-time-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="即时配送">
              <el-switch ></el-switch>
            </el-form-item>
            <el-form-item label="活动性质">
              <el-checkbox-group >
                <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
                <el-checkbox label="地推活动" name="type"></el-checkbox>
                <el-checkbox label="线下主题活动" name="type"></el-checkbox>
                <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="特殊资源">
              <el-radio-group >
                <el-radio label="线上品牌商赞助"></el-radio>
                <el-radio label="线下场地免费"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="活动形式">
              <el-input type="textarea" ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" >立即创建</el-button>
              <el-button>取消</el-button>
            </el-form-item>
            <div class="grid-content bg-purple">
              <el-input placeholder="网站顶部标题" >
                <template slot="prepend">网站标题</template>
              </el-input>
              <el-input placeholder="搜索引擎的关键字" >
                <template slot="prepend">关键字</template>
              </el-input>
            </div>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'ZCFB'
}
</script>
<style scoped>
  .demo-box {
    background-color: #fff;
  }
  .demo-block {
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: .2s;
  }
  .formdiv {
    padding: 36px;
  }
</style>



// WEBPACK FOOTER //
// src/components/zhongchou/ZCFB.vue